export const NavigationTypes = Object.freeze({
  BACKSTAGE: 'backstage',
  DIRECTORY: 'directory',
  VIEW_ALL: 'viewAll',
});
